@if (!(isInitialCommunicationLoading$ | async)) {
  <div
    class="root"
    skyTranslationGuard="skypro-communication"
    data-test="чат без вложенных сообщений"
  >
    @if ((threadCount$ | async) === 0) {
      <div class="empty-message" data-test="пустой список обсуждений">
        @if (!(isLoading$ | async)) {
          <img class="empty-message-image" [src]="empty" />
          <span
            class="empty-message-content"
            [innerHtml]="'skyproCommunications.empty' | transloco"
          ></span>
        }
      </div>
    }

    <div class="threads" #threadsContainer>
      <!--
        Лоадер будет отображаться и при отправке сообщения, из-за общего флага для загрузки всего.
        Оставил так, потому что 1. выглядит более менее 2. пользователь это увидит только если в обсуждениях пусто 3. не хочу усложнять логику
      -->
      @if (isLoading$ | async) {
        <div class="loader">{{ 'skyproCommunications.loadingThreads' | transloco }}</div>
      }

      @for (message of combinedMessages$ | async; track identify($index, message)) {
        @if (isThread(message)) {
          @if ((editingMessageId$ | async) !== message.content.id) {
            <skypro-communication-flat-view-message
              #threadRefs
              [message]="message.content"
              [canEdit]="message.content.author.user.id === currentUserId"
              [canDelete]="message.content.author.user.id === currentUserId"
              [baseApiHost]="baseApiHost()"
              (edit)="startEditing(message.content.id)"
              (delete)="deleteThread(message.content.id)"
              (createAiMessageReport)="doCreateAiMessageReport(message.content)"
              data-test="сообщение треда"
            ></skypro-communication-flat-view-message>
          } @else {
            <skypro-communication-form
              [editMessageContent]="message.content"
              [isMessengerMode]="true"
              (finishEditing)="finishEditing()"
              data-test="форма редактирования"
            ></skypro-communication-form>
          }
        }

        @if (isExternalEvent(message)) {
          @if (!message.content.meta?.isDebug || isDebugCuratorTalksEnabled) {
            <div class="event-container">
              <div class="event-line"></div>
              <div class="event-title" data-test="метка задачи amoCRM">
                {{ message.content.text }}
                @if (isToday(message.content.createdAt)) {
                  ({{ message.content.createdAt | date: 'HH:mm' }})
                } @else {
                  ({{ message.content.createdAt | date: 'dd.MM.yy HH:mm' }})
                }
              </div>
              <div class="event-line"></div>
            </div>
          }
        }
      }
      <ng-content select="[after-last-message]"></ng-content>
    </div>

    <div class="create-new-thread-form">
      <skypro-communication-form
        [hasAutofocus]="true"
        [isMessengerMode]="true"
        [needSaveInProgressText]="needSaveInProgressText"
        [localStorageKey]="localStorageKey"
        [inputDisabledPlaceholder]="inputDisabledPlaceholder()"
        (createdThread)="onThreadCreated()"
      ></skypro-communication-form>

      @if (showScrollToLatestButton$ | async) {
        <div class="new-messages">
          @if (newMessagesCount$ | async; as newMessagesCount) {
            @if (newMessagesCount > 0) {
              <div class="new-messages-count">{{ newMessagesCount }}</div>
            }
          }
          <ds-button
            class="new-messages-button"
            size="m"
            type="secondary"
            [isAloneIcon]="true"
            (click)="scrollToLatestThread()"
          >
            <ds-icon-dropdown icon></ds-icon-dropdown>
          </ds-button>
        </div>
      }
    </div>
  </div>
}
